import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpClient } from '@angular/common/http';
import { AbstractSettingsService } from './abstract-settings.service';

@Injectable()
export class AssetPerformanceService extends AbstractSettingsService {
    constructor(httpClient: HttpClient, configService: ConfigService) {
        super(httpClient, configService);
    }

    public async getAssetPerformanceList(): Promise<any> {
        const response = await this.getAssetPerformance();
        return response.result;
    }
}